import { preparePortalNotificationRead } from './notificationReadActions';
import {
  isSamePortalPath,
  navigatePortalPath,
  resolvePortalNotificationPath,
} from './portalNotificationRouting';
import {
  isPortalNotificationUnread,
  normalizePortalNotificationSource,
} from './portalNotificationSource';

/**
 * Single entry for notification click/open: mark read then navigate.
 * Awaits mark-as-read when navigation would reload the current page so the API is not aborted.
 */
export const openPortalNotification = async (source, { userRole, navigate, markRead } = {}) => {
  const normalized = normalizePortalNotificationSource(source);
  const path = resolvePortalNotificationPath(normalized, userRole);

  if (!path || !navigate) {
    return { path: path ?? null, markedRead: false };
  }

  const prepared =
    markRead && isPortalNotificationUnread(normalized)
      ? preparePortalNotificationRead(normalized)
      : null;

  let markedRead = false;

  if (prepared) {
    const willReload = isSamePortalPath(path);

    if (willReload && typeof markRead.mutateAsync === 'function') {
      try {
        await markRead.mutateAsync(source);
        markedRead = true;
      } catch {
        markedRead = false;
      }
    } else if (typeof markRead.mutate === 'function') {
      markRead.mutate(source);
      markedRead = true;
    }
  }

  navigatePortalPath(navigate, path);

  return { path, markedRead };
};
